import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import * as forumActions from "../../actions/forumActions";
import { useForm } from "react-hook-form";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

const Answer = (props) => {

  const { userdata, actions, refreshForum } = props;
  const { register, formState: { errors }, handleSubmit } = useForm();
  const [getLoader, setGetLoader] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const onSubmit = async (data) => {
    setGetLoader(true);
    const request = {};
    request.user_id = userdata.user_id;
    request.ques_id = userdata.ques_id;
    request.answer = data.answer;
    const result = await actions.saveForumAnswer(request, props);
    if (result.success) {
    refreshForum(); // Reload forum list
  }
    setGetLoader(false);
    // Show popup message after response
    setPopupMessage(result.message);
    setShowPopup(true);
  };

  const hasAnswer = Boolean(userdata?.user_ans);
  const isLoading = getLoader;

  let buttonText;

  if (hasAnswer) {
    buttonText = isLoading ? "Updating..." : "Update";
  } else {
    buttonText = isLoading ? "Submitting..." : "Submit";
  }

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered className="calendar-modal"
      >
        <Modal.Header closeButton><h3><b>Answer</b></h3></Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="mentor_detail align-items-center">
              <Col sm={12}>
                <Form.Control
                  as="textarea"
                  className={
                    errors.answer ? "form-control is-invalid" : "form-control"
                  }
                  defaultValue={userdata?.user_ans || ""}
                  aria-invalid={errors.answer ? "true" : "false"}
                  {...register("answer", {
                    maxLength: 250,
                    required: true
                  })}
                />
                {errors.answer && errors.answer?.type === "required" && (
                  <label className="customeValidationText text-left" htmlFor="answer">
                    Please enter answer
                  </label>
                )}
                {errors.answer && errors.answer?.type === "maxLength" && (
                  <label className="customeValidationText text-left" htmlFor="answer">
                    Answer should not more than 250 characters
                  </label>
                )}
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <div className="form-group mt-3 text-left">
                  <Button
                    className="btn nextbtn ml-2"
                    type="submit"
                    disabled={getLoader}
                  >
                    {buttonText}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false);
          props.onHide()
        }}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

    </>
  );
};

Answer.propTypes = {
  userdata: PropTypes.shape({
    user_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ques_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    user_ans: PropTypes.string,
  }).isRequired,
  actions: PropTypes.shape({
    saveForumAnswer: PropTypes.func.isRequired,
  }).isRequired,
  onHide: PropTypes.func.isRequired,
  refreshForum: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...forumActions },
      dispatch
    ),
  };
}

// export default connect(mapDispatchToProps)(Answer);
export default connect(null, mapDispatchToProps)(Answer);
